import { roundToTwoDecimals } from './numberWithSpaces'

const handleNavigate = (record) => {
	const mappedRecord = {
		...record,
		documentLines: record.documentLines.map((item) => ({
			...item,
			koef: item.u_Coefficient,
			ugpCode: item.ugpCode,
			u_PlannedQuantity: item.u_PlannedQuantity,
			shippedQuantity:
				+item.u_PlannedQuantity -
				+roundToTwoDecimals(
					item.openQty /
						(((item.u_Width * item.u_Height) / 1000000) * 1),
				),
			shippedQuantityKvm: item.quantity - item.openQty,
			oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
			openQuantitySon: roundToTwoDecimals(
				item.openQty / (((item.u_Width * item.u_Height) / 1000000) * 1),
			),
		})),
	}

	console.log('record', mappedRecord)
	sessionStorage.setItem('orderData', JSON.stringify(mappedRecord))

	const url = `/orders`
	window.open(url, '_blank')
}

const handleNavigateFinishedSales = (record) => {
	const mappedRecord = {
		...record,
		documentLines: record.documentLines.map((item) => ({
			...item,
			koef: item.u_Coefficient,
			ugpCode: item.ugpCode,
			u_PlannedQuantity: item.u_Kvmetr,
			shippedQuantity: +item.u_Kvmetr,
			shippedQuantityKvm: item.quantity - item.openQty,
			oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
			openQuantitySon: roundToTwoDecimals(
				item.openQty / (((item.u_Width * item.u_Height) / 1000000) * 1),
			),
		})),
	}

	console.log('record', mappedRecord)
	sessionStorage.setItem('orderData', JSON.stringify(mappedRecord))

	const url = `/orders`
	window.open(url, '_blank')
}

const handleNavigateMiniDashboard = (record) => {
	const mappedRecord = {
		...record,
		documentLines: record.documentLines.map((item) => ({
			...item,
			koef: item.u_Coefficient,
			ugpCode: item.ugpCode,
			u_PlannedQuantity: item.u_PlannedQuantity,
			shippedQuantity:
				+item.u_PlannedQuantity -
				+roundToTwoDecimals(
					item.openQty /
						(((item.u_Width * item.u_Height) / 1000000) * 1),
				),
			shippedQuantityKvm: item.quantity - item.openQty,
			oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
			openQuantitySon: roundToTwoDecimals(
				item.openQty / (((item.u_Width * item.u_Height) / 1000000) * 1),
			),
		})),
	}

	console.log('record', mappedRecord)
	sessionStorage.setItem(
		'salesMiniDashboardData',
		JSON.stringify(mappedRecord),
	)

	const url = `/salesMiniDashboard?docEntry=${record.docEntry}`
	window.open(url, '_blank')
}

const handleNavigatePrintIncoming = (record) => {
	console.log('record', record)
	sessionStorage.setItem('receiptData', JSON.stringify(record))

	const url = `/receipt`
	window.open(url, '_blank')
}

const handleNavigateCar = (record) => {
	const mappedRecord = {
		...record,
		documentLines: record.documentLines.map((item) => ({
			...item,
			koef: item.u_Coefficient,
			ugpCode: item.ugpCode,
			u_PlannedQuantity: item.u_PlannedQuantity,
			shippedQuantity:
				+item.u_PlannedQuantity -
				+roundToTwoDecimals(
					item.openQty /
						(((item.u_Width * item.u_Height) / 1000000) * 1),
				),
			shippedQuantityKvm: item.quantity - item.openQty,
			oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
			openQuantitySon: roundToTwoDecimals(
				item.openQty / (((item.u_Width * item.u_Height) / 1000000) * 1),
			),
		})),
	}

	console.log('record', mappedRecord)

	sessionStorage.setItem('orderData', JSON.stringify(mappedRecord))

	const url = `/marshrut`
	window.open(url, '_blank')
}

const handleNavigateCarFinishedSales = (record) => {
	// Bu hozirchaga qilindi backend u_PlannedQuantity ni to'g'irlagandan kyn chopamiza
	const mappedRecord = {
		...record,
		documentLines: record.documentLines.map((item) => ({
			...item,
			koef: item.u_Coefficient,
			ugpCode: item.ugpCode,
			u_PlannedQuantity: item.u_Kvmetr,
			shippedQuantity: item.u_Kvmetr,
			shippedQuantityKvm: item.quantity - item.openQty,
			oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
			openQuantitySon: roundToTwoDecimals(
				item.openQty / (((item.u_Width * item.u_Height) / 1000000) * 1),
			),
		})),
	}

	console.log('record', mappedRecord)

	sessionStorage.setItem('orderData', JSON.stringify(mappedRecord))

	const url = `/marshrut`
	window.open(url, '_blank')
}

const handleNavigateCarInvoices = (record, purchaseOrderDocNum) => {
	console.log('record', record)

	sessionStorage.setItem('invoicesMarshrutData', JSON.stringify(record))
	sessionStorage.setItem(
		'purchaseOrderDocNumMarshrutData',
		JSON.stringify(purchaseOrderDocNum),
	)

	const url = `/invoicesMarshrut`
	window.open(url, '_blank')
}

const handleNavigateSeries = (record) => {
	console.log('record', record)
	localStorage.setItem('seriesDocEntry', JSON.stringify(record.docEntry))
	const url = `/series-barcode`
	window.open(url, '_blank')
}

const handleMarshrutWorkers = (record) => {
	console.log('record', record)
	localStorage.setItem(
		'marshrutDocEntry',
		JSON.stringify(record.salesOrderDocEntry),
	)
	const url = `/marshrut-for-workers`
	window.open(url, '_blank')
}

const handleNavigateSeriesProdManager = (record) => {
	console.log('record', record)
	localStorage.setItem('seriesData', JSON.stringify(record))
	const url = `/prod-manager-series-barcode`
	window.open(url, '_blank')
}

const handleNavigateSeriesProdWorkers = (record) => {
	console.log('record', record)
	localStorage.setItem('seriesData', JSON.stringify(record))
	const url = `/series-one-barcode`
	window.open(url, '_blank')
}

export {
	handleNavigate,
	handleNavigateCar,
	handleNavigateSeries,
	handleMarshrutWorkers,
	handleNavigateSeriesProdManager,
	handleNavigateSeriesProdWorkers,
	handleNavigateCarInvoices,
	handleNavigatePrintIncoming,
	handleNavigateMiniDashboard,
	handleNavigateCarFinishedSales,
	handleNavigateFinishedSales,
}
